export default {
    methods: {
        appendArrayFilterIfNonEmpty(params, name, value) {
            if (typeof value === 'undefined' || null === value) {
                return;
            }

            const values = Array.from(value);

            if (!values.length) {
                return;
            }

            params[name] = values;
        },
        appendBoolFilterIfNonEmpty(params, name, value, onlyExpectedEvaluation = null) {
            if (typeof value === 'undefined' || null === value) {
                return;
            }

            // Cast to integer to avoid recognizing the value incorrectly by API ("false" -> true).
            const bit = (true === value || 1 === value) + 0

            if (null !== onlyExpectedEvaluation && (!!bit !== !!onlyExpectedEvaluation)) {
                return
            }

            params[name] = bit;
        },
        appendIntFilterIfNonEmpty(params, name, value) {
            if (typeof value === 'undefined' || null === value) {
                return;
            }

            const v = parseInt(String(value).trim(), 10);

            if (isNaN(v)) {
                return;
            }

            params[name] = v;
        },
        appendRangeFilterIfNonEmpty(params, name, value, expectedMin = null, expectedMax = null) {
            if (!(value instanceof Array) || !value.length) {
                return
            }

            const min = value[0];
            const max = value[1];

            if (null !== expectedMin && null !== expectedMax && // Range validation requested.
                min <= expectedMin && max >= expectedMax
            ) {
                // Full range or outside range.
                return
            }

            params[name] = [min, max];
        },
        appendStringFilterIfNonEmpty(params, name, value, minLength) {
            if (typeof value === 'undefined' || null === value) {
                return;
            }

            const v = String(value).trim();

            if (!minLength || v.length >= minLength) {
                params[name] = v;
            }
        }
    }
}